import React from "react";
import { userActions } from "dashboard-utils/lib";
import { showBanner } from "../utils/ShowNewBanner";
import { ENV } from "./env";

export const MENU_SECTIONS = {
  SUMMARY: {
    id: "summary",
    items: [
      {
        text: "Business Summary",
        icon: "home-with-rupee",
        path: "/business",
        classProp: "new-mer-tour-step1 mig-mer-tour-step1",
        isConsolidateCompatible: true,
        isMCCCompatible: false,
      },
    ],
  },
  TRACK: {
    id: "track",
    items: [
      {
        verifyAccess: {
          action: userActions.TRANSACTION.VIEW,
          message: {
            title: 'Track payments',
            content: 'You currently don\'t have permission'
          }
        },
        icon: "up-down",
        text: "Transactions",
        path: "/business/transactions",
        isConsolidateCompatible: true,
        isMCCCompatible: true,
      },
      {
        icon: "bank-with-arrow",
        text: "Settlements",
        path: "/business/settlements",
        verifyAccess: {
          action: userActions.SETTLEMENT.VIEW,
          message: {
            title: 'Track settlements',
            content: 'You currently don\'t have permission'
          }
        },
        isConsolidateCompatible: true,
        isMCCCompatible: true,
      },
      {
        icon: "rotation",
        text: "Chargeback",
        newTab: true,
        path: process.env.CHARGEBACK_HOST,
        verifyAccess: {
          action: userActions.CHARGEBACK,
          message: {
            title: 'Chargeback',
            content: 'You currently don\'t have permission'
          }
        },
        extras: {
          link: {
            openInNewTab: true,
          },
        },
      },
      {
        icon: "report",
        text: "Reports",
        path: "/business/reports",
        classProp: "mig-mer-tour-step6",
        isConsolidateCompatible: true,
        isMCCCompatible: true,
      },
    ],
  },
  PAYMENTS_PRODUCTS: {
    id: "payment_products",
    title: {
      text: "PAYMENT PRODUCTS",
    },
    items: [
      {
        icon: "earth",
        text: "Payment Gateway",
        path: "/business/payment-gateway",
        extras: {
          // isNew: showBanner("payment-gateway-new-feature-flag", 15),
        },
      },
      {
        id: "payment_tools",
        icon: "tools",
        text: "Payment Tools",
        // path: "/business/payment-gateway",
        expanded: false,
        items: [
          {
            icon: "payment-link",
            text: "Payment Links",
            path: "/business/payment-links",
            verifyAccess: {
              action: userActions.PAYMENT_LINKS_LIST.VIEW,
              message: {
                title: 'Payment Links',
                content: 'You currently don\'t have permission'
              }
            },
          },
          {
            icon: "cursor",
            text: "Payment Buttons",
            path: "/business/buttons",
            verifyAccess: {
              action: userActions.BUTTON.VIEW,
              message: {
                title: 'Payment Buttons',
                content: 'You currently don\'t have permission'
              }
            },
          },
          {
            icon: "document",
            text: "Invoices",
            path: "/business/invoices",
            extras: {
              // isNew: showBanner("tools-invoice-new-banner-", 15),
            },
            verifyAccess: {
              action: userActions.INVOICES.VIEW,
              message: {
                title: 'Invoices',
                content: 'You currently don\'t have permission'
              }
            },
          },
        ],
      },
      {
        icon: "split",
        text: "Split & Transfer Payments",
        path: "/business/aggregator",
      },
      {
        icon: "offer",
        text: "Offers & Promotions​",
        path: "/business/offer/overview",
        enablementKey: "offerEngineEnabled",
        extras: {
          // isNew: showBanner("offer-engine-new-banner", 15),
        },
      },
      process.env.CURRENT_ENV !== ENV.UAT ?
        {
          icon: "widget",
          text: "Affordability Widget",
          path: "/business/widget"
        } : null,
      {
        icon: "link",
        text: "Maximizer",
        path: "/business/maximizer",
        enablementKey: "switchPayEnabled",
      }
    ].filter(Boolean)
  },
  LAUNCHPAD: {
    id: "launchpad",
    hideBottomBorder: true,
    items: [
      {
        icon: "rocket",
        text: "Launchpad",
        path: "/business/front-office",
        extras: {
          // isNew: showBanner("front-office-new-banner-", 15),
        },
      },
    ],
  },
  SEND_PAYMENTS: {
    id: "send-payments",
    hideBottomBorder: true,
    title: {
      text: "SEND PAYMENTS",
    },
    items: [
      {
        icon: "payout",
        text: "Payouts",
        path: "/business/payouts",
        verifyAccess: {
          action: userActions.PAYOUT.ANY,
          message: {
            title: 'Payouts',
            content: 'You currently don\'t have permission'
          },
          matchAny: true,
        },
      },
      // {
      //   icon: "beneficiary",
      //   text: "Beneficiary",
      //   path: "/business/beneficiary",
      //   enablementKey: "nbEligible",
      // },
    ],
  },
  BANKING: {
    id: "banking",
    hideBottomBorder: true,
    title: {
      text: "Banking",
    },
    items: [
      {
        verifyAccess: {
          action: userActions.NEO_BANKING.ACCESS,
          matchAny: true,
        },
        icon: "bank",
        text: "Banking Dashboard",
        path: "/banking/dashboard",
      },
      // {
      //   verifyAccess: {
      //     action: userActions.ACCOUNT_PAYABLES.OWNER,
      //     matchAny: true,
      //   },
      //   icon: "card-with-arrow",
      //   text: "Vendor Payments",
      //   path: "/banking/payables",
      // },
      // {
      //   icon: "integration",
      //   text: "Integrations",
      //   path: "/banking/integrations",
      // },
    ],
    enablementKey: "nbEligible",
  },
  LENDING: {
    id: "lending",
    hideBottomBorder: true,
    title: {
      text: "Lending",
    },
    items: [
      {
        verifyAccess: {
          action: userActions.NEO_LENDING.ACCESS,
          matchAny: true,
        },
        icon: "flex-cash",
        text: "Early Settlements",
        path: "/lending/early-settlements",
        enablementKey: "nbEligible",
      },
      {
        verifyAccess: {
          action: userActions.NEO_LENDING.ACCESS,
          matchAny: true,
        },
        icon: "flex-cash",
        text: "FlexiCash",
        
      },
    ],
  },
  SETTINGS: {
    id: "settings",
    items: [
      {
        icon: "gear",
        text: "Settings",
        path: "/business/settings",
      },
    ],
  },
  DIAGNOSTIC_TOOL: {
    id: "diagnostic-tool",
    hidden: false,
    items: [
      {
        icon: "signal-tower",
        text: "Diagnostic Tool",
        path: "/business/diagnostic-tool",
      },
    ],
  },
  NEOBANKING: {
    id: "neobanking",
    hideBottomBorder: true,
    title: {
      text: "NEOBANKING",
    },
    items: [
      {
        icon: "customer-support",
        text: "Vista",
        path: "/business/vista/info",
        classProp: "new-mer-tour-step1 mig-mer-tour-step1",
        extras: {
          // isNew: true,
        },
        newTab: true,
        vistaRedirect: true,
      },
      {
        icon: "payout",
        text: "Payouts",
        path: "/business/vista/payouts",
        classProp: "new-mer-tour-step1 mig-mer-tour-step1",
      },
    ],
  },
};
